<template>
  <section class="px-3">
    <Carousel :items-to-show="3" :items-to-scroll="1" :breakpoints="breakpoints" arrows class="carousel-container">
      <Slide v-for="(img, index) in sliderImages" :key="index">
        <img :src="img.url" alt="" class="img-fluid w-100">
      </Slide>
      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </section>
  <section v-html="generalText">
  </section>
</template>
<script setup>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { defineProps } from 'vue';
  defineProps({
    sliderImages: {
      type: Object,
      required: true,
    },
    generalText: {
      type: String,
      required: true,
    },
  });

// Carousel breakpoints
const breakpoints = {
  320: { itemsToShow: 1 },
  1024: { itemsToShow: 3 },
  1440: { itemsToShow: 3 }
};
</script>
<style scoped>
.carousel-container {
  margin-inline: -10px;
}

.carousel-container ::v-deep .carousel__prev {
  left: -30px;
  margin: 0;
}

.carousel-container ::v-deep .carousel__next {
  right: -30px;
  margin: 0;
}

.carousel__slide {
  padding-inline: 10px;
}

@media screen and (max-width: 598px) {
  .carousel-container ::v-deep .carousel__prev {
    left: -20px;
    margin: 0;
  }

  .carousel-container ::v-deep .carousel__next {
    right: -20px;
    margin: 0;
  }
}
</style>
